import React, { useState } from "react";
import { Card, Tabs, Button, Image, Badge } from "antd";
import { CalendarOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import localeData from "dayjs/plugin/localeData";
import styled from "@emotion/styled";
import timetable from "@/assets/images/timetable.svg";

const DaysStyled = styled("div")({
  ".ant-image": {
    marginRight: "6px",
  },
  minWidth: "412px",
  boxShadow:
    //  "0px 2px 4px #bfbfbf;",
    "0 1px 2px -2px #e4e4e429,0 1px 2px -2px #0000001f,0 1px 2px -2px #00000017",
  ".ant-tabs-extra-content": {
    color: `#74d93`,
  },
  ">div>.ant-tabs-nav": {
    // padding: "0px 24px",
    background: "linear-gradient(to bottom, #eef0ff, #f6f7ff)",
    paddingRight: "12px",
    ".ant-tabs-tab-active": {
      ".ant-tabs-tab-btn": {
        color: "#000",
        fontWeight: "bold",
      },
    },
  },

  ".ant-tabs-tab-active": {
    background: "#fff",
    fontSize: "16px",
  },
});
const ContentStyled = styled("div")({
  padding: "8px 24px",
  ".ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn": {
    color: `#074d93`,
  },
  ".ant-tabs-ink-bar-animated": {
    background: "#FFD400 !important",
    width: "32px !important",
    marginLeft: "16px !important",
  },
  ".addSedu": {
    display: "inline-block",
    background: `#074d93`,
    padding: "2px 12px",
    borderRadius: "10px",
    marginRight: "12px",
  },
  ".ant-btn": {
    height: "42px",
  },
  ".ant-card-body": {
    padding: "13px 24px",
  },
  ".daysSelect": {
    ":hover": {
      border: `1px solid #074d93`,
    },
  },
  ".ant-badge-status-dot": {
    position: "absolute",
    top: "-18px",
  },
});

dayjs.extend(localeData);
dayjs.locale("zh-cn");

const Schedule = ({ msg }) => {
  // 获取当前周的日期
  const startOfWeek = dayjs().startOf("week");
  const days = Array.from({ length: 7 }, (_, i) => startOfWeek.add(i, "day"));
  // 选中的日期
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );

  const meetings = [
    {
      time: "9:30-10:30",
      title: "新学期工作交流座谈会暨工会主席例会",
      location: "行政楼504会议室",
      date: dayjs().format("YYYY-MM-DD"),
    },
  ];

  const Content = () => {
    return (
      <ContentStyled className="px-6">
        {/* 日期选择 */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          {days.map((day, index) => (
            <div
              key={day.format("YYYY-MM-DD")}
              onClick={() => setSelectedDate(day.format("YYYY-MM-DD"))}
              style={{
                textAlign: "center",
                padding: 8,
                borderRadius: "16px",
                cursor: "pointer",
                background:
                  selectedDate === day.format("YYYY-MM-DD")
                    ? `linear-gradient(to bottom, rgb(1,77,153), rgb(49,129,211))`
                    : "#f5f5f5",
                color:
                  selectedDate === day.format("YYYY-MM-DD") ? "#fff" : "#333",
                width: 40,
                height: "42px",
              }}
              className="daysSelect"
            >
              <div style={{ lineHeight: "14px" }}>{day.format("D")}</div>
              <div style={{ fontSize: 12 }}>{day.format("MMM")}</div>
              {[0, 1, 3, 4]?.includes(index) && <Badge color={"#faaf1a"} />}
            </div>
          ))}
        </div>

        {/* 会议/课程选项卡 */}
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane
            tab={<span style={{ fontWeight: "bold" }}>我的会议</span>}
            key="1"
          >
            {meetings
              .filter((m) => m.date === selectedDate)
              .map((meeting, index) => (
                <Card
                  key={index}
                  style={{
                    background: "#F5F8FF",
                    borderRadius: 8,
                    marginBottom: 8,
                  }}
                >
                  <div className="flex items-center justify-between">
                    <div style={{ fontSize: 12 }}>{meeting.time}</div>
                    <div className="ml-3">
                      <div
                        style={{
                          fontWeight: "bold",
                          lineHeight: "33px",
                          width: "100%",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          color: `#074d93`,
                        }}
                      >
                        {meeting.title}
                      </div>
                      <div style={{ fontSize: 12, color: "#666" }}>
                        会议地点:{" "}
                        <span
                          style={{
                            color: `#074d93`,
                          }}
                        >
                          {meeting.location}
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
          </Tabs.TabPane>

          <Tabs.TabPane tab="我的课程" key="2">
            <div style={{ textAlign: "center", color: "#999" }}>暂无课程</div>
          </Tabs.TabPane>
        </Tabs>

        {/* 添加日程按钮 */}

        <Button
          type="dashed"
          icon={
            <div className="addSedu">
              <PlusOutlined style={{ color: "#fff" }} />
            </div>
          }
          block
          style={{ marginTop: 12, marginBottom: "16px" }}
        >
          添加日程
        </Button>
      </ContentStyled>
    );
  };
  return (
    <DaysStyled style={{ borderRadius: 12 }}>
      {/* 头部 */}
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: 16,
        }}
      >
        <span style={{ fontSize: 18, fontWeight: "bold" }}>我的日程</span>
      </div> */}
      <Tabs
        type="card"
        className="tabsTop"
        tabBarExtraContent={
          <span style={{ fontSize: 14 }}>
            <Image src={timetable} preview={false} />
            {dayjs().format("YYYY年M月")}{" "}
            <span className="pl-1">第{Math.ceil(dayjs().date() / 7)}周</span>
          </span>
        }
        items={[
          {
            label: "我的日程",
            key: "1",
            children: <Content />,
          },
        ]}
      />
    </DaysStyled>
  );
};

export default Schedule;
